// extracted by mini-css-extract-plugin
export default {"modalTitle":"style_modalTitle__z46je","modalBlur":"style_modalBlur__zVJNm","closeButton":"style_closeButton__+yW12","modalFooter":"style_modalFooter__unYWN"};